import * as angular from 'angular';
import * as _ from "lodash";
import {AnalyticsService} from "../../commons/services/analytics-service.service";
import {Expense} from "../../expenses/models/expenses.model";
import {IQService, IWindowService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {DeliveriesAlertsService} from "./deliveries-alerts.service";
import {DeliveriesRequestsService} from "./deliveries-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {ServicesFacadeService} from "../angular/services/services-facade.service";
import {take, takeWhile} from "rxjs";
import {Service} from "../models/service.model";
import {ServiceType} from "../types/service.type";
import {LeanPlanningService} from "../../lean-planning/services/lean-planning-service.service";
import {PrinterService} from "../../commons/services/printer-service.service";
import {
  ServicesMovePackagesResponseModel,
  SplitServicesPayloadModel
} from "../models/services-move-packages-payload.model";
import {ServiceStatus} from "../constants/service-status.type";

const ALLOWED_STATUSES_FOR_SPLIT = [
  ServiceStatus.Unassigned,
  ServiceStatus.Assigned,
];

export class ServicesService {

  private deliveriesRef: any;
  private redirectStatesByType: any;
  private blockResetAction: boolean;
  private printerProvider: any;

  constructor(private $delivery, private $q: IQService, private deliveriesConstants, private splitService: SplitService, private $window: IWindowService,
              private analyticsService: AnalyticsService, private deliveriesRequestsService: DeliveriesRequestsService, private deliveriesAlertsService: DeliveriesAlertsService,
              private tasksConstants, private bringozLoaderService: BringozLoaderService, private $state, private servicesFacadeService: ServicesFacadeService,
              private leanPlanningService: LeanPlanningService, private printerService: PrinterService) {

    this.deliveriesRef = this.$delivery();
    this.redirectStatesByType = this.deliveriesConstants.redirectStatesByType;
    this.blockResetAction = this.splitService.getServiceBlockResetAction();
    this.printerProvider = this.splitService.getPrinterProvider();
  }

  getActionsByServices(services, routes?) {

    const allActions = this.deliveriesConstants.actions;
    const actionsByTypeAndStatus = this.deliveriesConstants.serviceActionsByStatusMap;
    const startedStatuses = this.deliveriesConstants.startedStatuses;
    const extraActionsByStatusMap = this.deliveriesConstants.serviceExtraActionsByStatusMap
    const servicesExtraActions = this.deliveriesConstants.servicesExtraActions;
    const autonomousServiceActions = this.deliveriesConstants.autonomousServiceActions;


    // Routes Actions
    if (routes?.length) {
      const routesActions = this.leanPlanningService.getRoutesActionsMap(routes);
      if (routesActions.sendToPlanning) {
        return [allActions.SendToPlanning];
      } else {
        return [];
      }
    } else {
      const hasFinished = _.some(services, (s) => {
        return s.status === this.tasksConstants.status.Completed ||
          s.status === this.tasksConstants.status.Canceled
      });

      if (hasFinished && services.length > 1) {
        return [];
      }

      const actionsByType: any = {};
      const serviceByTypeCount = {
        Delivery: 0,
        Operation: 0
      };
      let hasStartedServices = false;
      let hasLowQualityAddress = false;
      let hasRoutedServices = false;
      let hasOperationServices = false;
      let hasAutonomousService = false;

      let allServicesAbortedCanceledPickupSameAgent = true;
      let allServicesAbortedCanceledDropoffCompletedPickup = true;

      _.forEach(services, (s) => {

        if (s.serviceType === ServiceType.Operation) {
          hasOperationServices = true;
        }
        if (s.routeId) {
          hasRoutedServices = true;
        }

        if (s.lockActionsInfo?.actionsLocked) {
          hasAutonomousService = true;
        }
        //Dropoff Abort Flow
        if (allServicesAbortedCanceledPickupSameAgent) {
          if (s.taskList[0].taskSpec.purpose !== "Pickup" || s.taskList[0].status !== "CourierDeparted" ||
            s.taskList[1].taskSpec.purpose !== "Dropoff" || s.taskList[1].status !== "Canceled") {
            allServicesAbortedCanceledDropoffCompletedPickup = false
          }
        }

        _.forEach(s.taskList, task => {

          //Pickup Abort Flow
          if (allServicesAbortedCanceledPickupSameAgent) {
            if ((task.taskSpec.purpose === "Pickup" || task.taskSpec.purpose === "Operation") &&
              (s.taskList[0].status !== "Canceled" || s.agentId !== services[0].agentId)) {
              allServicesAbortedCanceledPickupSameAgent = false
            }
          }

          if (task.taskSpec.address.qualityGroup === 'Low') {
            hasLowQualityAddress = true;
          }
        })
        serviceByTypeCount[s.serviceType]++;
        const serviceActions = actionsByTypeAndStatus[s.serviceType][s.status];
        if (!actionsByType[s.serviceType] || actionsByType[s.serviceType].length) {
          actionsByType[s.serviceType] = serviceActions;
          return;
        }
        if (_.includes(startedStatuses, s.status)) {
          hasStartedServices = true;
        }
        //Get only the common actions between current added actions and the service actions.
        actionsByType[s.serviceType] = _.intersectionWith(actionsByType[s.serviceType], actionsByTypeAndStatus[s.serviceType][s.status], _.isEqual)
      });
      //Abort flow pickup canceled remove action
      if (!allServicesAbortedCanceledPickupSameAgent) {
        actionsByType.Delivery = _.filter(actionsByType.Delivery, (a) => {
          return a.id !== "assignCanceledPickup"
        })

        actionsByType.Operation = _.filter(actionsByType.Operation, (a) => {
          return a.id !== "assignCanceledPickup"
        })

      }

      //Abort flow dropoff canceled remove action
      if (!allServicesAbortedCanceledDropoffCompletedPickup) {
        actionsByType.Delivery = _.filter(actionsByType.Delivery, (a) => {
          return a.id !== "reassignCanceledDropoff"
        })
      }

      // Uniq values only. just for safety.
      actionsByType.Delivery = _.intersectionBy(actionsByType.Delivery, 'id');
      actionsByType.Operation = _.intersectionBy(actionsByType.Operation, 'id');

      var hasDeliveryActions = !!actionsByType.Delivery.length;
      var hasOperationActions = !!actionsByType.Operation.length;
      if (hasStartedServices || (hasDeliveryActions && hasOperationActions)) {
        actionsByType.Delivery = _.filter(actionsByType.Delivery, (a) => {
          return a.id !== 'createRoute';
        });
        actionsByType.Operation = _.filter(actionsByType.Operation, (a) => {
          return a.id !== 'createRoute';
        });
      }

      if (hasLowQualityAddress) {
        actionsByType.Delivery = _.filter(actionsByType.Delivery, (a) => {
          return a.id !== 'autoAssignAgent';
        });
      }

      if (!hasOperationServices) {
        actionsByType.Delivery.push(servicesExtraActions.PrintIkea);
      }

      //XOR aka just one of them
      if ((hasDeliveryActions || hasOperationActions) && !(hasDeliveryActions && hasOperationActions) && !hasFinished) {
        hasDeliveryActions ? actionsByType.Delivery.push(allActions.EditTimeWindow) : actionsByType.Operation.push(allActions.EditTimeWindow)
      }

      // if (hasDeliveryActions && hasRoutedServices) {
      //   actionsByType.Delivery = _.filter(actionsByType.Delivery , (a)=>{
      //     return a !== allActions.EditLocation;
      //   })
      // }
      //
      // if (hasOperationActions && hasRoutedServices) {
      //   actionsByType.Operation = _.filter(actionsByType.Operation , (a)=>{
      //     return a !== allActions.EditLocation;
      //   })
      // }

      if (services.length > 1) {

        if (hasDeliveryActions) {
          actionsByType.Delivery = this._removeSingleServiceActions(actionsByType.Delivery);
        }

        if (hasOperationActions) {
          actionsByType.Operation = this._removeSingleServiceActions(actionsByType.Operation);
        }
      } else if (services.length === 1) {

        const service = services[0];
        const edit = _.find(extraActionsByStatusMap[service.serviceType][service.status], (action) => {
          return action.id === 'edit'
        });

        const duplicate = _.find(extraActionsByStatusMap[service.serviceType][service.status], (action) => {
          return action.id === 'Duplicate'
        });

        const print = _.find(extraActionsByStatusMap[service.serviceType][service.status], (action) => {
          return action.id === 'Print'
        });

        const printLabel = _.find(extraActionsByStatusMap[service.serviceType][service.status], (action) => {
          return action.id === 'PrintLabel'
        });

        const downloadLabel = _.find(extraActionsByStatusMap[service.serviceType][service.status], (action) => {
          return action.id === 'DownloadLabel'
        });

        const createExpense = _.find(extraActionsByStatusMap[service.serviceType][service.status], (action) => {
          return action.id === 'CreateExpense'
        });

        const dispatchExternal = _.find(extraActionsByStatusMap[service.serviceType][service.status], (action) => {
          return action.id === 'dispatchExternal'
        });

        const editPackages = _.find(extraActionsByStatusMap[service.serviceType][service.status], (action) => {
          return action.id === 'editPackages'
        });

        if (hasDeliveryActions) {
          if (!!edit) {
            actionsByType.Delivery.push(edit);
          }
          if (!!duplicate) {
            actionsByType.Delivery.push(duplicate);
          }
          if (!!editPackages) {
            actionsByType.Delivery.push(editPackages);
          }
          if (!!print) {
            actionsByType.Delivery.push(print);
          }
          if (!!printLabel) {
            actionsByType.Delivery.push(printLabel);
          }
          if (!!downloadLabel) {
            actionsByType.Delivery.push(downloadLabel);
          }
          if (!!createExpense) {
            actionsByType.Delivery.push(createExpense);
          }
          if (!!dispatchExternal && service.fulfillmentId && service.fulfillmentStepId) {
            actionsByType.Delivery.push(dispatchExternal);
          }
        }

        if (hasOperationActions) {
          if (!!edit) {
            actionsByType.Operation.push(edit);
          }
          if (!!duplicate) {
            actionsByType.Operation.push(duplicate);
          }
          if (!!editPackages) {
            actionsByType.Operation.push(editPackages);
          }
          if (!!print) {
            actionsByType.Operation.push(print);
          }
          if (!!printLabel) {
            actionsByType.Operation.push(printLabel);
          }
          if (!!downloadLabel) {
            actionsByType.Operation.push(downloadLabel);
          }
          if (!!createExpense) {
            actionsByType.Operation.push(createExpense);
          }
          if (!!dispatchExternal && service.fulfillmentId && service.fulfillmentStepId) {
            actionsByType.Operation.push(dispatchExternal);
          }
        }
      }

      var filteredActions = actionsByType.Delivery.length && actionsByType.Operation.length ?
        _.intersectionWith(actionsByType.Delivery, actionsByType.Operation, _.isEqual) :
        (actionsByType.Delivery.length ? actionsByType.Delivery : actionsByType.Operation);

      // // Routes Actions
      // if (routeIds?.length) {
      //   filteredActions.push(allActions.SendToPlanning);
      //   // const sendToPlanningEnabled = _.find(filteredActions, (a) => {
      //   //   return a.id === allActions.SendToPlanning.id;
      //   // })
      //   //
      //   // if (!sendToPlanningEnabled) {
      //   //   filteredActions.push(allActions.SendToPlanning);
      //   // }
      // }

      if (this.blockResetAction) {
        filteredActions = filteredActions.filter(a => a.id !== 'reset');
      }

      if (!!hasAutonomousService && !this.splitService.getDisableEntityLockStateValue()) {
        filteredActions = filteredActions.filter(a => autonomousServiceActions.includes(a.id));
      }

      if (!this.printerService.getPrintingConfig().enabled) {
        filteredActions = filteredActions.filter(a => a.id !== 'PrintLabel');
      }

      if (this.printerProvider !== 'Ikea') {
        filteredActions = filteredActions.filter(a => a.id !== 'PrintIkea');
      }

      return _.intersectionBy(filteredActions, 'id');
    }
  }

  getLogsTimeline(serviceId) {
    this.bringozLoaderService.on();
    return this.deliveriesRequestsService.getLogsTimeline(serviceId)
      .catch((error) => {
        this.deliveriesAlertsService.getTimelineError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  onEditOne(service, newTab?: boolean) {
    const state = this.redirectStatesByType[service.serviceType].edit;
    if (state) {
      if (newTab) {
        const url = this.$state.href(state, {id: service.id});
        this.$window.open(url, '_blank')
      } else {
        this.$state.go(state, {id: service.id});
      }
    }
  }


  onDuplicateOne(service) {
    const state = this.redirectStatesByType[service.serviceType].duplicate;
    if (state) {
      this.$state.go(state, {
        id: service.accountId,
        serviceId: service.id
      });
    }
  }

  onPrint(serviceIds, printTaskPurpose?: string) {
    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('print.services', {
      siteId: siteId,
      servicesIds: serviceIds,
      printTaskPurpose: printTaskPurpose
    });
    this.analyticsService.trackEvent('Deliveries Actions', 'Print', 'Click');
    this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
  }


  createRecurringService(recurringService) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.createRecurringService(recurringService)
      .then((createdRecurringService) => {
        this.deliveriesAlertsService.createRecurringServiceSuccess(createdRecurringService);
        // this.deliveriesAlertsService.createDeliverySuccess(createdRecurringService);
        return deferred.resolve(createdRecurringService);
      })
      .catch((error) => {
        this.deliveriesAlertsService.createDeliveryError();
        return deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateRecurringService(id, recurringService) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateRecurringService(id, recurringService)
      .then((updatedRecurringService) => {
        this.servicesFacadeService.updateOne(updatedRecurringService);
        this.deliveriesAlertsService.updateDeliverySuccess(updatedRecurringService);
        return deferred.resolve(updatedRecurringService);
      })
      .catch((error) => {
        this.deliveriesAlertsService.updateDeliveryError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteRecurringServices(ids) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.deleteRecurringServices(ids)
      .then((deletedServices) => {
        this.deliveriesAlertsService.deleteRecurringServiceSuccess();
        return deferred.resolve(deletedServices);
      })
      .catch((error) => {
        if (error.code === 412205) {
          this.deliveriesAlertsService.deleteRecurringServiceHasResourceError(ids);
        } else {
          this.deliveriesAlertsService.deleteRecurringServiceError();
        }
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateBulk(ids, payload, rePrice, sendSms?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateBulk(ids, payload, rePrice, sendSms)
      .then((updatedServices) => {
        this.servicesFacadeService.updateMany(updatedServices);
        this.deliveriesAlertsService.updateBulkSuccess();
        return deferred.resolve(updatedServices);
      })
      .catch((error) => {
        this.deliveriesAlertsService.updateBulkError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getRecurringServices(branchIds, accountIds) {
    this.bringozLoaderService.on();
    return this.deliveriesRequestsService.getRecurringServices(branchIds, accountIds)
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getServices(ids) {
    this.bringozLoaderService.on();
    return this.deliveriesRef.$asyncValues(ids)
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  getAssignResourceAllocationData(deliveryIds, from, to, type, branchIds) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.getAssignResourceAllocationData(deliveryIds, from, to, type, branchIds)
      .then((resourceAllocationData) => {
        return deferred.resolve(resourceAllocationData);
      })
      .catch((error) => {
        this.deliveriesAlertsService.getResourceAllocationsDataError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  movePackages(serviceId: string, payload: SplitServicesPayloadModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.movePackages(serviceId, payload)
      .then((resourceAllocationData: ServicesMovePackagesResponseModel) => {
        if (resourceAllocationData.createdServiceIds.length > 0) {
          this.deliveriesAlertsService.movePackagesSuccess(resourceAllocationData.createdServiceIds[0]).then(action => {
            if (action) {
              this.$state.go('service.delivery.info', { id: resourceAllocationData.createdServiceIds[0] });
            }
          });
        }
        return deferred.resolve(resourceAllocationData);
      })
      .catch((error) => {
        this.deliveriesAlertsService.movePackagesError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  addServicesToResource(deliveryIds, assignDeliveries, allocationInstanceId, resourceEventEntityId, supplyResourceSource, onlyOptimized, attachedVehicleToUpdate?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.addServicesToResource(deliveryIds, assignDeliveries, allocationInstanceId, resourceEventEntityId, supplyResourceSource, onlyOptimized, attachedVehicleToUpdate)
      .then((updatedServices) => {
        this.servicesFacadeService.updateMany(updatedServices);
        deliveryIds.length > 1 ? this.deliveriesAlertsService.addToResourceAllocationMultiSuccess() : this.deliveriesAlertsService.addToResourceAllocationSuccess()
        return deferred.resolve(updatedServices);
      })
      .catch((error) => {
        deliveryIds.length > 1 ? this.deliveriesAlertsService.addToResourceAllocationMultiError() : this.deliveriesAlertsService.addToResourceAllocationError()
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  bulkUpdateLocation(payload, serviceIds, rePrice) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.bulkUpdateLocation(payload, serviceIds, rePrice)
      .then((updatedServices) => {
        this.servicesFacadeService.updateMany(updatedServices);
        this.deliveriesAlertsService.updateBulkSuccess();
        return deferred.resolve(updatedServices);
      })
      .catch((error) => {
        this.deliveriesAlertsService.updateBulkError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  bulkUpdateTaskSpec(payload) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.bulkUpdateTaskSpec(payload)
      .then((updatedServices) => {
        this.deliveriesAlertsService.updateBulkSuccess();
        return deferred.resolve(updatedServices);
      })
      .catch((error) => {
        this.deliveriesAlertsService.updateBulkError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  onDeleteServiceNote(serviceId, noteId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.deleteNote(serviceId, noteId)
      .then((service) => {
        this.servicesFacadeService.updateOne(service);
        this.deliveriesAlertsService.deleteServiceNoteSuccess();
      })
      .catch((error) => {
        this.deliveriesAlertsService.deleteServiceNoteError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getServiceExpenses(serviceId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.getExpenses(serviceId)
      .then((expenses: Expense[]) => {
        return deferred.resolve(expenses);
      })
      .catch((error) => {
        this.deliveriesAlertsService.getServiceExpensesError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  assignServiceToAgent(serviceIds, agentId, doForce?, doReset?, removeServiceFromRoute?) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.assignToAgent(serviceIds, agentId, doForce, doReset, removeServiceFromRoute)
      .then((res) => {
        this.servicesFacadeService.updateOne(res);
        this.deliveriesAlertsService.assignSuccess();
        return deferred.resolve(res);
      })
      .catch((error) => {
        this.deliveriesAlertsService.assignError(error);
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateCompletedService(serviceId: string, service) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateCompletedService(serviceId, service)
      .then((res) => {
        this.servicesFacadeService.updateOne(res);
        this.deliveriesAlertsService.updateDeliverySuccess(res);
        return deferred.resolve(res);
      })
      .catch((error) => {
        this.deliveriesAlertsService.updateDeliveryError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateTaskLocation(serviceId: string, taskId: string, taskSpec: any, updateOrder?: boolean, sendSms?: boolean, rePrice?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateTaskLocation(serviceId, taskId, taskSpec, updateOrder, sendSms, rePrice)
      .then((res) => {
        this.servicesFacadeService.updateOne(res);
        this.deliveriesAlertsService.updateDeliverySuccess(res);
        return deferred.resolve(res);
      })
      .catch((error) => {
        this.deliveriesAlertsService.updateDeliveryError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateReferenceIds(serviceId: string, referenceIds: string[], updateOrder?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.updateReferenceIds(serviceId, referenceIds, updateOrder)
      .then((res) => {
        this.servicesFacadeService.updateOne(res);
        this.deliveriesAlertsService.updateDeliverySuccess(res);
        return deferred.resolve(res);
      })
      .catch((error) => {
        this.deliveriesAlertsService.updateDeliveryError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  unlinkRelatedTask(serviceId: string, taskId: string, relatedTaskId: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.deliveriesRequestsService.unlinkRelatedTask(serviceId, taskId, relatedTaskId)
      .then((res) => {
        this.servicesFacadeService.updateOne(res);
        this.deliveriesAlertsService.unlinkRelatedTaskSuccess();
        return deferred.resolve(res);
      })
      .catch((error) => {
        this.deliveriesAlertsService.unlinkRelatedTaskError();
        return deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  isSplitAllowedForStatus(status: ServiceStatus): boolean {
    return this.splitService.getSiteInfo().allowSplitDispatchedOrders && ALLOWED_STATUSES_FOR_SPLIT.includes(status);
  }

  private _removeSingleServiceActions(actions) {
    return _.filter(actions, function (a) {

      return a.id !== 'note' || a.id !== 'editTimeWindow';
    })
  }


}

angular
  .module('bringoz.admin.deliveries')
  .service('servicesService', ServicesService);
